import { forwardRef, type CSSProperties, type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

type StackGap = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 8 | 10 | 12;

const gapMap: Record<StackGap, string> = {
  0: "bfrs-gap-0",
  1: "bfrs-gap-1",
  2: "bfrs-gap-2",
  3: "bfrs-gap-3",
  4: "bfrs-gap-4",
  5: "bfrs-gap-5",
  6: "bfrs-gap-6",
  8: "bfrs-gap-8",
  10: "bfrs-gap-10",
  12: "bfrs-gap-12"
};

export type StackProps = HTMLAttributes<HTMLDivElement> & {
  direction?: "row" | "column";
  gap?: StackGap;
  align?: CSSProperties["alignItems"];
  justify?: CSSProperties["justifyContent"];
  wrap?: boolean;
};

export const Stack = forwardRef<HTMLDivElement, StackProps>(
  ({ className, direction = "column", gap = 4, align, justify, wrap, style, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("bfrs-flex", direction === "row" ? "bfrs-flex-row" : "bfrs-flex-col", wrap && "bfrs-flex-wrap", gapMap[gap], className)}
      style={{ alignItems: align, justifyContent: justify, ...style }}
      {...props}
    />
  )
);

Stack.displayName = "Stack";
